import { AxiosResponse } from 'axios';
import { UploadedFile } from '../../../../types/files';
import { axiosInstance } from '../../../api/fesRequest/axios';
import { fileToBase64 } from '../../../common/fileToBase64';

export interface AffordabilityDocumentUploadRequestModel {
  file: {
    name: string;
    mimeType: string;
    base64: string;
  };
}

export interface AffordabilityDocumentUploadResponseModel {
  id: string;
}

export type AffordabilityDocumentUpdateRequestModel = MediaStorageService.Schemas.FilesRequest;

export interface AffordabilityDocumentUpdateResponseModel {
  id: string;
}

export interface AffordabilityDocumentDeleteResponseModel {
  id: string;
}

export const uploadAffordabilityDocument = async (
  file: UploadedFile,
  onUploadProgress: (percentCompleted: number, bytesSent: number, totalBytes: number) => void
): Promise<AxiosResponse<AffordabilityDocumentUploadResponseModel>> => {
  const b64data = await fileToBase64(file, true);

  const config = {
    onUploadProgress(progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      onUploadProgress(percentCompleted, progressEvent.loaded, progressEvent.total);
    },
  };

  return axiosInstance.post<AffordabilityDocumentUploadResponseModel>(
    '/affordabilityDocument',
    {
      file: {
        name: file.name,
        mimeType: file.type,
        base64: b64data,
      },
    },
    config
  );
};

export const deleteAffordabilityDocument = (
  fileId: string
): Promise<AxiosResponse<AffordabilityDocumentDeleteResponseModel>> => {
  return axiosInstance.delete<AffordabilityDocumentUploadResponseModel>(`/affordabilityDocument/${fileId}`);
};

export const updateAffordabilityDocument = (
  fileId: string,
  metadata: AffordabilityDocumentUpdateRequestModel
): Promise<AxiosResponse<AffordabilityDocumentUpdateResponseModel>> => {
  return axiosInstance.patch<AffordabilityDocumentUploadResponseModel>(`/affordabilityDocument/${fileId}`, metadata);
};
